import { render } from "./ChartController.vue?vue&type=template&id=db47d1d6&scoped=true"
import script from "./ChartController.vue?vue&type=script&lang=js"
export * from "./ChartController.vue?vue&type=script&lang=js"

import "./ChartController.vue?vue&type=style&index=0&id=db47d1d6&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db47d1d6"]])

export default __exports__